import { render, staticRenderFns } from "./TierPricingSetting.vue?vue&type=template&id=81d4a63e&scoped=true&"
import script from "./TierPricingSetting.vue?vue&type=script&lang=js&"
export * from "./TierPricingSetting.vue?vue&type=script&lang=js&"
import style0 from "./TierPricingSetting.vue?vue&type=style&index=0&id=81d4a63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d4a63e",
  null
  
)

component.options.__file = "TierPricingSetting.vue"
export default component.exports